import { render, staticRenderFns } from "./ConstructionManagement.vue?vue&type=template&id=063d76f9&"
import script from "./ConstructionManagement.vue?vue&type=script&lang=js&"
export * from "./ConstructionManagement.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionManagement.vue?vue&type=style&index=0&id=063d76f9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports